import { CustomMenuItemProps } from '../../components/Menu/CustomMenu';
import PATHS from '../../routes/routes.const';

const { admin } = PATHS;

export const menuItems: CustomMenuItemProps[] = [
  {
    label: 'clientes',
    group: true,
    items: [
      {
        label: 'marcas',
        name: 'brands',
        pathname: admin.adminBrands.path,
      },
      {
        label: 'lojas',
        name: 'stores',
        pathname: admin.adminStores.path,
      },
      {
        label: 'usuários',
        name: 'profile',
        pathname: admin.adminUsers.path,
      },
    ],
  },
  {
    label: 'configurações',
    group: true,
    items: [
      {
        label: 'banners',
        name: 'banners',
        pathname: admin.adminBanners.path,
      },
      {
        label: 'comunicados',
        name: 'announcements',
        pathname: admin.adminAnnouncements.path,
      },
      {
        label: 'destaques',
        name: 'highlights',
        pathname: admin.adminHighlights.path,
      },
      {
        label: 'parâmetros',
        name: 'params',
        pathname: admin.adminParams.path,
      },
      {
        label: 'usuários teceo',
        name: 'profile',
        pathname: admin.adminTeceoUsers.path,
      },
      {
        label: 'integrações',
        name: 'integrations',
        pathname: admin.adminIntegrations.path,
      },
    ],
  },
];
